import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { Label } from 'core/components/label';
import useStyles from './agent-cancellation-note.styles';

/**
 * The cancellation instructions an agent sees in place of Cancel Policy (#37502), as an info callout in
 * light text with the underwriting inbox as a mailto link. In the infoValue color it read as one of the
 * disabled controls around it on the dark Policy Actions card (#37594). The Label keeps its default type,
 * which sets no color, so `classes.note` decides it; `inlineDisplay` replaces the Label's display: flex,
 * which would drop the spaces around the link. `note` is getAgentCancellationNote's sentence, unchanged;
 * only the `email` inside it becomes the link.
 */
const AgentCancellationNote = ({ note, email }) => {
  const classes = useStyles();
  // A sentence that doesn't carry the email prints as plain text rather than split around a missing match.
  const emailAt = note.lastIndexOf(email);
  return (
    <div className={classes.callout}>
      <InfoOutlinedIcon className={classes.icon} data-testid="agent-cancellation-note-icon" />
      <Label component="p" inlineDisplay className={classes.note} data-testid="agent-cancellation-note">
        {emailAt === -1 ? (
          note
        ) : (
          <>
            {note.slice(0, emailAt)}
            <a className={classes.link} href={`mailto:${email}`}>
              {email}
            </a>
            {note.slice(emailAt + email.length)}
          </>
        )}
      </Label>
    </div>
  );
};

AgentCancellationNote.propTypes = {
  note: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
};

export default AgentCancellationNote;
